export enum ViewTypes {
  CARD_VIEW = 'CARD_VIEW',
  LIST_VIEW = 'LIST_VIEW',
}

export enum PoolSelection {
  ALL = 'ALL',
  MYPOOLS = 'MYPOOLS',
}
